export default __webpack_public_path__ + "static/media/04.d34c9b87.jpg";